export const MODEL_CHANGE = "MODEL_CHANGE";
export const MODEL_UPDATED = "MODEL_UPDATED";
export const MODEL_STATE_UPDATE = "MODEL_STATE_UPDATE";

const modelChangeAction = (payload) => ({
    type: MODEL_CHANGE,
    modelPayload: payload
});

const isModelUpdatedAction = (payload) => ({
    type: MODEL_STATE_UPDATE,
    status: payload
});

const setModifiedDateAction = (payload) => ({
    type: MODEL_UPDATED,
    datePayload: payload

});

export { modelChangeAction, isModelUpdatedAction, setModifiedDateAction };